// src/app/modules/Visitors/pages/visitors-table/column-formatters/ActionsColumnFormatter.jsx
import React from "react";
import { Eye, Flag, AlertTriangle, Ban } from 'lucide-react';

export function ActionsColumnFormatter(cellContent, row, rowIndex, { onViewDetails, onFlag, onAddThreat, onBlacklist }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 }}>
      <button
        title="View Details"
        className="sety-btn sety-btn-ghost"
        style={{ padding: '6px 10px' }}
        onClick={() => onViewDetails(row.profile_id)}
      >
        <Eye size={15} />
      </button>

      {!row.flagged_at && (
        <button
          title="Flag Visitor"
          className="sety-btn sety-btn-ghost"
          style={{ padding: '6px 10px' }}
          onClick={() => onFlag(row.profile_id)}
        >
          <Flag size={15} />
        </button>
      )}

      <button
        title="Create Threat Alert"
        className="sety-btn sety-btn-ghost"
        style={{ padding: '6px 10px' }}
        onClick={() => onAddThreat(row.profile_id)}
      >
        <AlertTriangle size={15} />
      </button>

      <button
        title="Add to Blacklist"
        className="sety-btn sety-btn-danger"
        style={{ padding: '6px 10px' }}
        onClick={() => onBlacklist(row.profile_id)}
      >
        <Ban size={15} />
      </button>
    </div>
  );
}
